import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Text } from '@components/Reference';
import Sandbox from '@components/Sandbox';
import Cell from '@components/Cell';
import { Spacer, Container, Row, Col } from '@cleartrip/bento/lib';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "grid"
    }}>{`Grid`}</h1>
    <p>{`The grid system provides us with a device agnostic layout system.`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
  <Property mdxType="Property">
    <Name mdxType="Name">.container</Name>
    <Text mdxType="Text">Sets width and centers outermost div</Text>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.row</Name>
    <Text mdxType="Text">Aligns children columns</Text>
  </Property>
  <Property mdxType="Property">
    <Name mdxType="Name">.col</Name>
    <Text mdxType="Text">Set width of individual column</Text>
  </Property>
    </Reference>
    <h2 {...{
      "id": "grid-construction"
    }}>{`Grid construction`}</h2>
    <p>{`A basic grid is constructed out of three elements, `}<inlineCode parentName="p">{`.container`}</inlineCode>{`, `}<inlineCode parentName="p">{`.row`}</inlineCode>{` and `}<inlineCode parentName="p">{`.col`}</inlineCode></p>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row mdxType="Row">
        <Col mdxType="Col">
          <Cell mdxType="Cell">col-12</Cell>
        </Col>
        <Col mdxType="Col">
          <Cell mdxType="Cell">col-12</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="container">
      <div className="row">
        <div className="col-12">...</div>
        <div className="col-12">...</div>
      </div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={16} mdxType="Spacer" />
    <h2 {...{
      "id": "grid-combinations"
    }}>{`Grid combinations`}</h2>
    <p>{`A 24 column grid allows us to make a varied range of layouts. These are some of the possible layouts.`}</p>
    <Spacer my={8} mdxType="Spacer" />
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row mdxType="Row">
        <Col span={1} mdxType="Col">
          <Cell mdxType="Cell">1</Cell>
        </Col>
        <Col span={23} mdxType="Col">
          <Cell mdxType="Cell">col-23</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={2} mdxType="Col">
          <Cell mdxType="Cell">col-2</Cell>
        </Col>
        <Col span={22} mdxType="Col">
          <Cell mdxType="Cell">col-22</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={3} mdxType="Col">
          <Cell mdxType="Cell">col-3</Cell>
        </Col>
        <Col span={21} mdxType="Col">
          <Cell mdxType="Cell">col-21</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={4} mdxType="Col">
          <Cell mdxType="Cell">col-4</Cell>
        </Col>
        <Col span={20} mdxType="Col">
          <Cell mdxType="Cell">col-20</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={5} mdxType="Col">
          <Cell mdxType="Cell">col-5</Cell>
        </Col>
        <Col span={19} mdxType="Col">
          <Cell mdxType="Cell">col-19</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={6} mdxType="Col">
          <Cell mdxType="Cell">col-6</Cell>
        </Col>
        <Col span={18} mdxType="Col">
          <Cell mdxType="Cell">col-18</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={7} mdxType="Col">
          <Cell mdxType="Cell">col-7</Cell>
        </Col>
        <Col span={17} mdxType="Col">
          <Cell mdxType="Cell">col-17</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
        <Col span={16} mdxType="Col">
          <Cell mdxType="Cell">col-16</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={9} mdxType="Col">
          <Cell mdxType="Cell">col-9</Cell>
        </Col>
        <Col span={15} mdxType="Col">
          <Cell mdxType="Cell">col-15</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={10} mdxType="Col">
          <Cell mdxType="Cell">col-10</Cell>
        </Col>
        <Col span={14} mdxType="Col">
          <Cell mdxType="Cell">col-14</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={11} mdxType="Col">
          <Cell mdxType="Cell">col-11</Cell>
        </Col>
        <Col span={13} mdxType="Col">
          <Cell mdxType="Cell">col-13</Cell>
        </Col>
      </Row>
      <Spacer my={4} mdxType="Spacer" />
      <Row mdxType="Row">
        <Col span={12} mdxType="Col">
          <Cell mdxType="Cell">col-12</Cell>
        </Col>
        <Col span={12} mdxType="Col">
          <Cell mdxType="Cell">col-12</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="container">
      <div className="row">
        <div className="col-1">...</div>
        <div className="col-24">...</div>
      </div>
      <div className="row">
        <div className="...">...</div>
        <div className="...">...</div>
      </div>
      <div className="row">
        <div className="col-24">...</div>
        <div className="col-1">...</div>
      </div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={16} mdxType="Spacer" />
    <h2 {...{
      "id": "offset-columns"
    }}>{`Offset columns`}</h2>
    <p>{`It's possible to leave some some columns empty. The syntax for that is `}<inlineCode parentName="p">{`col-offest-{number}`}</inlineCode></p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
        <Col span={12} offset={4} mdxType="Col">
          <Cell mdxType="Cell">col-12 (offset by 4 columns)</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="container">
      <div className="row">
        <div className="col-8">...</div>
        <div className="col-12 col-offset-4">...</div>
      </div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={16} mdxType="Spacer" />
    <h2 {...{
      "id": "alignment"
    }}>{`Alignment`}</h2>
    <p>{`Add classes to align elements to the start, end and center of the row. Notice that these classes are applied on the `}<inlineCode parentName="p">{`row`}</inlineCode>{` element.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row start mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row end mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row center mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="container">
      <div className="row start">
        <div className="col-8">...</div>
      </div>
      <div className="row end">
        <div className="col-8">...</div>
      </div>
      <div className="row center">
        <div className="col-8">...</div>
      </div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={16} mdxType="Spacer" />
    <h2 {...{
      "id": "distribution"
    }}>{`Distribution`}</h2>
    <p>{`Add the `}<inlineCode parentName="p">{`around`}</inlineCode>{` or `}<inlineCode parentName="p">{`between`}</inlineCode>{` classes to distribute the contents of the row. Notice that these classes are applied on the `}<inlineCode parentName="p">{`row`}</inlineCode>{` element.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row around mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row between mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">col-8</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="container">
      <div className="row around">
        <div className="col-8">...</div>
        <div className="col-8">...</div>
      </div>
      <div className="row between">
        <div className="col-8">...</div>
        <div className="col-8">...</div>
      </div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={16} mdxType="Spacer" />
    <h2 {...{
      "id": "ordering"
    }}>{`Ordering`}</h2>
    <p>{`It possible to alter the order of the colmumns using the `}<inlineCode parentName="p">{`last`}</inlineCode>{` or `}<inlineCode parentName="p">{`fist`}</inlineCode>{` classes. Notice that these classes are applied on the `}<inlineCode parentName="p">{`col`}</inlineCode>{` element.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">1</Cell>
        </Col>
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">2</Cell>
        </Col>
        <Col span={8} first mdxType="Col">
          <Cell dark mdxType="Cell">3</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Spacer my={4} mdxType="Spacer" />
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row mdxType="Row">
        <Col span={8} last mdxType="Col">
          <Cell dark mdxType="Cell">1</Cell>
        </Col>
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">2</Cell>
        </Col>
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">3</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="container">
      <div className="row">
        <div className="col-8">1</div>
        <div className="col-8">2</div>
        <div className="col-8 first">3</div>
      </div>
      <div className="row">
        <div className="col-8 last">1</div>
        <div className="col-8">2</div>
        <div className="col-8">3</div>
      </div>
    </div>
  </Sandbox.Code>
    </Sandbox>
    <Spacer my={16} mdxType="Spacer" />
    <h2 {...{
      "id": "reversing"
    }}>{`Reversing`}</h2>
    <p>{`You can reverse the order of the columns by adding a `}<inlineCode parentName="p">{`reverse`}</inlineCode>{` class to the `}<inlineCode parentName="p">{`row`}</inlineCode>{`.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <Container mdxType="Container">
      <Row reverse mdxType="Row">
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">1</Cell>
        </Col>
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">2</Cell>
        </Col>
        <Col span={8} mdxType="Col">
          <Cell mdxType="Cell">3</Cell>
        </Col>
      </Row>
    </Container>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="container">
      <div className="row reverse">
        <div className="col-8">1</div>
        <div className="col-8">2</div>
        <div className="col-8">3</div>
      </div>
    </div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      